import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { get } from "../helper/helper_api";
import moment from "moment/moment";

function Footer() {
  const [data, setData] = useState(undefined);
  useEffect(() => {
    console.log("body");
    get("/lastUpdate")
      .then((res) => {
        console.log("last Update res", res);
        setData(res?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);
  return (
    <footer>
      <div className="container">
        <div className="footer-in">
          <div className="row">
            <div className="col-sm-12 text-center foot">
              <Link to="/gallery">Gallery</Link> | <a href="#">Terms of Use</a>{" "}
              |{" "}
              <a href="sitemap.xml" target="_blank" rel="noopener noreferrer">
                Site Map
              </a>{" "}
              | <Link to="/inquiry">Inquiry</Link> |{" "}
              <a
                href="http://rajmith.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Website Designed &amp; Developed By{" "}
                <img src="images/rajmith.png" alt="" />
              </a>{" "}
              <span class="last-update">
                {" "}
                {/* Corrected class name */}
                <u>
                  Last Updated: {/* Use moment to format the date */}
                  {data?.[0]?.last_updated &&
                    moment(data?.[0]?.last_updated).format("DD-MMM-YYYY")}
                </u>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
